import { render, staticRenderFns } from "./CaririskRaporu.vue?vue&type=template&id=486c9a4d&"
import script from "./CaririskRaporu.vue?vue&type=script&lang=js&"
export * from "./CaririskRaporu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports